import { render } from "./BasicButton.vue?vue&type=template&id=5c8d1b42&ts=true"
import script from "./BasicButton.vue?vue&type=script&lang=ts"
export * from "./BasicButton.vue?vue&type=script&lang=ts"

import "./BasicButton.vue?vue&type=style&index=0&id=5c8d1b42&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_release/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__